import { Box, Slider, SliderThumb, useTheme } from '@mui/material';
import { ElementType, HTMLAttributes } from 'react';
import { sliderContainerStyles, sliderStyles, sliderThumbStyles } from './CustomSlider.styles';
import TAGSvgIcon from '@shared-components/components/TAGSvgIcon';
export interface ICustomSliderProps {
  sliderValue: number;
  handleSliderChange: (event: Event, value: number | number[], activeThumb: number) => void;
}
export type ThumbComponentProps = HTMLAttributes<unknown>;
const ThumbComponent = (props: ThumbComponentProps) => {
  const theme = useTheme();
  const {
    children,
    ...other
  } = props;
  return <SliderThumb data-testid={'custom_slider_thumb'} {...other} style={sliderThumbStyles(props, theme)} data-sentry-element="SliderThumb" data-sentry-component="ThumbComponent" data-sentry-source-file="CustomSlider.tsx">
			<TAGSvgIcon icon={'ChevronLeftFunc'} size={34} htmlColor="white" data-sentry-element="TAGSvgIcon" data-sentry-source-file="CustomSlider.tsx" />
			{children}
			<TAGSvgIcon icon={'ChevronRightFunc'} size={34} htmlColor="white" data-sentry-element="TAGSvgIcon" data-sentry-source-file="CustomSlider.tsx" />
		</SliderThumb>;
};
const CustomSlider = ({
  sliderValue,
  handleSliderChange
}: ICustomSliderProps) => {
  const theme = useTheme();
  return <>
			<Box data-testid={'before_after_slider'} sx={sliderContainerStyles(sliderValue, theme)} data-sentry-element="Box" data-sentry-source-file="CustomSlider.tsx" />
			<Slider value={sliderValue} onChange={handleSliderChange} components={{
      Thumb: ThumbComponent as ElementType
    }} sx={sliderStyles} data-sentry-element="Slider" data-sentry-source-file="CustomSlider.tsx" />
		</>;
};
export default CustomSlider;